export const FIELD =
    "w-full rounded-xl border border-input bg-background px-4 py-3 text-sm outline-none transition-colors duration-200 placeholder:text-muted-foreground focus:border-primary aria-[invalid=true]:border-destructive";

export function Fieldset({ legend, children, testId }) {
    return (
        <fieldset className="rounded-2xl border border-border bg-surface p-6 md:p-8" data-testid={testId}>
            <legend className="px-3 font-display text-base font-bold text-primary md:text-lg">{legend}</legend>
            <div className="space-y-4">{children}</div>
        </fieldset>
    );
}

export function Req({ children }) {
    return (
        <div className="relative">
            <span aria-hidden="true" className="pointer-events-none absolute -left-3 top-3 font-bold text-destructive">*</span>
            {children}
        </div>
    );
}

export function Select({ placeholder, options, testId, ...props }) {
    return (
        <select className={`${FIELD} ${props.value ? "" : "text-muted-foreground"}`} data-testid={testId} {...props}>
            <option value="">{placeholder}</option>
            {options.map((o) => (
                <option key={o} value={o}>{o}</option>
            ))}
        </select>
    );
}
